<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :block="$vuetify.breakpoint.smAndDown"
  >
    Seuraava</v-btn
  >
</template>

<script>
export default {
  name: "NextButton",
};
</script>

<style scoped></style>
